import { isEmpty } from '@sgme/fp';
import { parseISO } from 'date-fns';
import { QuoteResult } from 'state/quotes/results/result.model';
import { getQuoteType } from 'state/quotes/selectors';
import { isQuoteTypeTradable } from 'state/quotes/utils';
import { AppState } from 'state/state.model';
import { dateNow } from 'utils/core/now';

export function isQuoteEligibleForExecution(state: AppState, quoteId: string, quote: QuoteResult): boolean {
  const quoteType = getQuoteType(state, quoteId);
  const { createdAt, tradeExecutionWindowInMilliseconds } = quote;
  const tradeExecWindow = tradeExecutionWindowInMilliseconds ?? 0;

  if (!isQuoteTypeTradable(quoteType) || isEmpty(createdAt) || tradeExecWindow === 0) {
    return false;
  }
  const now = dateNow();
  const quoteCreationTime = parseISO(createdAt).getTime();

  return quoteCreationTime + tradeExecWindow > now;
}
